import { format, parseISO } from 'date-fns';
import { Task, TaskPriority, TaskStatus } from '../../types/task.types';

// Complete literals so Tailwind's scanner sees every class.
export const PRIORITY_BG: Record<TaskPriority, string> = {
  CRITICAL: 'bg-sev-critical',
  HIGH: 'bg-sev-high',
  MEDIUM: 'bg-sev-medium',
  LOW: 'bg-sev-low',
};

// Human-readable status labels, shared by the list rows, the peek header, and
// the peek's status picker so a raw enum (IN_PROGRESS) never reaches the screen.
export const TASK_STATUS_LABEL: Record<TaskStatus, string> = {
  TODO: 'To do',
  IN_PROGRESS: 'In progress',
  REVIEW: 'Awaiting approval',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  ARCHIVED: 'Archived',
};

export type CheckboxState = 'empty' | 'half' | 'done' | 'void';

export function checkboxState(task: Task): CheckboxState {
  if (task.status === 'COMPLETED') return 'done';
  if (task.status === 'CANCELLED') return 'void';
  if (task.status === 'IN_PROGRESS' || task.status === 'REVIEW') return 'half';
  return 'empty';
}

// String compare against a local-formatted today, same trick as the register's
// review column: due_date is date-only, so no timezone conversion may happen.
export const isTaskOverdue = (task: Task): boolean =>
  task.status !== 'COMPLETED' &&
  task.status !== 'CANCELLED' &&
  !!task.dueDate &&
  task.dueDate < format(new Date(), 'yyyy-MM-dd');

// The year is part of the date. Without it a 2025 row and a 2026 row read
// identically, which matters most at the top of an ascending due-date list,
// exactly where the year turns over.
export const dueStamp = (task: Task, pattern = 'MMM d, yyyy'): string | null =>
  task.dueDate ? format(parseISO(task.dueDate), pattern).toUpperCase() : null;
